import { z } from "zod";

export interface ProductEntity {
  id: number;
  nombre: string;
  descripcion: string;
  activo: boolean;
}

export interface ProductDetail {
    id: number;
    nombre: string;
    descripcion: string;
    activo: boolean;
    numAdmis: string;
    idTipoProducto: number;
}

export interface ProductFilters {
  nombre?: string;
  descripcion?: string;
  activo?: boolean;
}

export const productCreationSchema = z.object({
  tipoProducto: z.any().optional(),
  nombre: z.any().optional(),
  numAdmis: z.any().optional(),
  unidadMedida: z.any().optional(),
  descripcion: z.any().optional(),
  activo: z.any().optional(),
});

export type ProductCreationFormData = z.infer<typeof productCreationSchema>;
